import styled from 'styled-components';

export const FooterWrapper = styled.footer`
  width: 100%;
  background-color: '#ffffff';

  background-repeat: no-repeat;
  background-position: bottom;
  background-size: 100%;
  padding: 5px 0 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 480px) {
    padding: 60px 0 50px;
  }
`;

export const BrokerWrapper = styled.div`
  margin-top: 40px;
  max-width: 1200px;
  @media (max-width: 991px) {
    max-width: 800px;
  }
`;

export const CopyrightArea = styled.div`
  color: '#909090';
  font-size: 15px;
  line-height: 18px;
  font-weight: 400;
  margin-top: 30px;
  @media (max-width: 480px) {
    font-size: 14px;
    margin-top: 20px;
  }
`;

export const FooterLogo = styled.img`
  display: 'inline-block';
  padding-top: 20;
  width: 350px;
  margin-left: 35;
`;



// WEBPACK FOOTER //
// ./src/Layouts/Footer/Footer.style.js